<template>
  <div class="third">
    <component :is="labelName" :ref="labelName" @changeComponent="setComponent"></component>
  </div>
</template>

<script>
import homePage from './components/homePage.vue';
import DetailsInfo from "./components/detailsInfo";
import particulars from "./components/particulars";

export default {
  name: 'userMan',
  data() {
    return {
      labelName: 'homePage',
    }
  },
  components: {
    homePage,
    DetailsInfo,
    particulars,
  },
  created() {
  },
  methods: {
    // 新增 编辑
    setComponent(val) {
      this.labelName = val
    },
  },
}
</script>
